import { render, staticRenderFns } from "./block-ai-feedback.vue?vue&type=template&id=60b1555d&scoped=true&lang=pug"
import script from "./block-ai-feedback.vue?vue&type=script&lang=js"
export * from "./block-ai-feedback.vue?vue&type=script&lang=js"
import style0 from "./block-ai-feedback.vue?vue&type=style&index=0&id=60b1555d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1555d",
  null
  
)

export default component.exports